import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { setCookie } from '../scenarios'

export type ReferrerUrlState = string | null

export const referrerSlice = createSlice({
  name: 'referrerUrl',
  initialState: null as ReferrerUrlState,
  reducers: {
    setReferrerUrl: (state: ReferrerUrlState, action: PayloadAction<string>) => {
      setCookie('referrerUrl', action.payload)
      return action.payload
    },
  },
})

export const { setReferrerUrl } = referrerSlice.actions
